/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const TaxSlice = createSlice({
  name: 'tax',
  initialState: {
    tax:[],
  },
  reducers: {
    setAllTax: (state, action) => {
      state.tax = action.payload;
    },
    updateTax(state, action) {
      const updatedItems = action.payload; // An array of updated items
      state.tax = state.tax.map((item) =>
        updatedItems.find((updated) => updated.key === item.key) || item
      );
    },
  },
});

export const { setAllTax, updateTax } = TaxSlice.actions;

export default TaxSlice.reducer;
